// extracted by mini-css-extract-plugin
export default {"timeMsg":"TimerProgressBar_timeMsg__0sD5b","timeMsgText":"TimerProgressBar_timeMsgText__Mh8iU"};